import { atom } from 'jotai';
import { pageStateVM, editStateVM, modelVM } from './provider_edit_view_models';
import { AdminProviderModel, EditState, ProviderEditPageState } from './provider_edit_types';

export const pageStateAtom = atom<ProviderEditPageState>(pageStateVM());
export const editStateAtom = atom<EditState>(editStateVM());
export const editModelAtom = atom<AdminProviderModel>(modelVM());
